/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateComponentClassRequestDto
 */
export interface UpdateComponentClassRequestDto {
    /**
     * Unique code for the component class
     * @type {string}
     * @memberof UpdateComponentClassRequestDto
     */
    code?: string;
    /**
     * Name of the component class
     * @type {string}
     * @memberof UpdateComponentClassRequestDto
     */
    name?: string;
    /**
     * Description of the component class
     * @type {string}
     * @memberof UpdateComponentClassRequestDto
     */
    description?: string | null;
    /**
     * List of synonyms for this component class
     * @type {Array<string>}
     * @memberof UpdateComponentClassRequestDto
     */
    synonyms?: Array<string>;
    /**
     * Parent component class ID (null to remove parent)
     * @type {string}
     * @memberof UpdateComponentClassRequestDto
     */
    parentId?: string | null;
    /**
     * Parent component class code as alternative to parentId
     * @type {string}
     * @memberof UpdateComponentClassRequestDto
     */
    parentCode?: string;
}

/**
 * Check if a given object implements the UpdateComponentClassRequestDto interface.
 */
export function instanceOfUpdateComponentClassRequestDto(value: object): value is UpdateComponentClassRequestDto {
    return true;
}

export function UpdateComponentClassRequestDtoFromJSON(json: any): UpdateComponentClassRequestDto {
    return UpdateComponentClassRequestDtoFromJSONTyped(json, false);
}

export function UpdateComponentClassRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateComponentClassRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'synonyms': json['synonyms'] == null ? undefined : json['synonyms'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'parentCode': json['parentCode'] == null ? undefined : json['parentCode'],
    };
}

export function UpdateComponentClassRequestDtoToJSON(json: any): UpdateComponentClassRequestDto {
    return UpdateComponentClassRequestDtoToJSONTyped(json, false);
}

export function UpdateComponentClassRequestDtoToJSONTyped(value?: UpdateComponentClassRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'description': value['description'],
        'synonyms': value['synonyms'],
        'parentId': value['parentId'],
        'parentCode': value['parentCode'],
    };
}

